import { normalizeWorkspaceSubstage } from './recuperacaoWorkspace';

export const ASSINADO_SUBSTAGE = 'pre-fecho-assinado';

export const ASSINATURA_NAO_MOTIVOS = [
  { key: 'aguarda-cliente', label: 'A aguardar assinatura do cliente' },
  { key: 'fidelizado', label: 'Fidelizado' },
  { key: 'nao-avancou', label: 'Cliente decidiu não avançar' },
  { key: 'outro', label: 'Outro' },
] as const;

export function isAssinadoSubstage(substage: string): boolean {
  return normalizeWorkspaceSubstage(substage) === ASSINADO_SUBSTAGE;
}
